/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：438
 */

module.exports = {
  hide: "style_hide__ydZDA",
  "coco-widget-wrapper": "style_coco-widget-wrapper__1nMbo",
  "coco-child-widget": "style_coco-child-widget__CPxve",
  "coco-child-widget-selected": "style_coco-child-widget-selected__2Chdr",
  "coco-child-widget-full": "style_coco-child-widget-full__2v-P3",
  timePicker: "style_timePicker__1-sYO",
  mask: "style_mask__2yghP"
}
